import React from "react";
import { Divider } from "@mui/material";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { changeLocale } from "translations/language-provider/actions";
import styles from "./LocaleSelector.module.css";

const LocaleSelector = ({ changeLocale, language }) => {
  return (
    <div className={styles.languageContainer}>
      <div className={styles.languageSelector} data-testid="language-selector">
        <div
          className={`${styles.languageOption} ${language === "pt" ? styles.activeLanguage : ""}`}
          data-lang="pt"
          role="button"
        >
          <span variant="body2" onClick={() => changeLocale("pt")}>
            PT
          </span>
        </div>
        <Divider orientation="vertical" flexItem className={styles.divider} />
        <div
          className={`${styles.languageOption} ${language === "en" ? styles.activeLanguage : ""}`}
          data-lang="en"
          role="button"
        >
          <span variant="body2" onClick={() => changeLocale("en")}>
            EN
          </span>
        </div>
        <Divider orientation="vertical" flexItem className={styles.divider} />
        <div
          className={`${styles.languageOption} ${language === "fr" ? styles.activeLanguage : ""}`}
          data-lang="fr"
          role="button"
        >
          <span variant="body2" onClick={() => changeLocale("fr")}>
            FR
          </span>
        </div>
      </div>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ changeLocale }, dispatch);
}

export default connect(null, mapDispatchToProps)(LocaleSelector);
